// The one way every screen writes spend: tokens abbreviated, money in
// dollars from micro-USD.

/**
 * Formats a token count for a glance screen: exact below a thousand, then
 * one decimal with a `k` or `M` suffix so 1.4M and 14.2M read apart.
 */
export function formatTokens(tokens: number): string {
  if (tokens >= 1_000_000) return `${(tokens / 1_000_000).toFixed(1)}M`;
  if (tokens >= 1_000) return `${(tokens / 1_000).toFixed(1)}k`;
  return `${tokens}`;
}

/**
 * Formats a micro-USD spend as dollars to two places with thousands
 * separators, and a spend under half a cent as `<$0.01` so it does not
 * read as free. The one formatter for spend, so no two screens disagree.
 */
export function formatSpend(micros: number): string {
  if (micros > 0 && micros < 5_000) return "<$0.01";
  const dollars = (micros / 1_000_000).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `$${dollars}`;
}

/**
 * Formats metered sandbox seconds for a glance screen: seconds under a
 * minute, then minutes, then hours and minutes.
 */
export function formatSandboxTime(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}
